import { publicRequest } from './core.api';

export interface RequestNewUserAccessNotificationRequest {
  notificationToken: string;
  preferredLocale: string;
}

export interface RequestEmailLoginRequest {
  email: string;
  preferredLocale: string;
  clientIpAddress: string | null;
  requestedAccountMode: 'landlord' | 'tenant' | null;
  postLoginIntent: 'pricing_checkout_resume' | null;
}

export interface LoginProvidersDto {
  emailEnabled: boolean;
  googleEnabled: boolean;
  googleClientId?: string | null;
  microsoftEnabled: boolean;
  microsoftClientId?: string | null;
}

export const authPublicApi = {
  getLoginProviders: () => publicRequest<LoginProvidersDto>('/auth/providers'),
  requestEmailLogin: (body: RequestEmailLoginRequest) => publicRequest<void>('/auth/email/request', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
  completeEmailLogin: (body: { token: string; clientIpAddress: string | null }) => publicRequest<{
    token: string;
    email: string;
    displayName: string;
    accountMode: 'landlord' | 'tenant';
    onboardingCompleted: boolean;
    postLoginIntent?: 'pricing_checkout_resume' | null;
  }>('/auth/email/complete', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
  requestNewUserAccessNotification: (body: RequestNewUserAccessNotificationRequest) => publicRequest<void>('/auth/signup-access-notifications', {
    method: 'POST',
    body: JSON.stringify(body),
  }),
};
